import * as THREE from 'three';

/** 行星配置接口 */
export interface PlanetConfig {
  name: string;
  nameCn: string;
  radius: number;         // 相对半径（地球 = 1）
  realRadius: number;     // 真实半径（km）
  orbitRadius: number;    // 轨道半径（场景单位）
  orbitEccentricity: number; // 轨道偏心率
  yearPeriod: number;     // 公转周期（地球日）
  rotationPeriod: number; // 自转周期（小时）
  axialTilt: number;      // 轴倾斜（度）
  color: number;          // 主体颜色
  emissive?: number;      // 自发光颜色（太阳用）
  hasRing?: boolean;      // 是否有光环
  ringInner?: number;     // 光环内径
  ringOuter?: number;     // 光环外径
  textureUrl?: string;    // 纹理贴图 URL
  info: string;           // 简介
  mass?: number;          // 质量（地球质量 = 1）
  gravity?: number;       // 表面重力（地球重力 = 1）
  temperature?: number;   // 表面温度（°C）
  moons?: number;         // 卫星数量
}

/** 手势事件类型 */
export interface GestureEvent {
  type: GestureType;
  hand: 'left' | 'right' | 'both';
  confidence: number;
  /** 主力手指（拇指/食指）在归一化屏幕坐标中的位置 [0,1]，左上角为(0,0) */
  handPosition?: { x: number; y: number };
  data?: Record<string, unknown>;
}

export enum GestureType {
  NONE = 'none',
  SCISSORS = 'scissors',       // 剪刀手（食指+中指V形）→ 选取行星
  OPEN_PALM = 'open_palm',     // 五指张开 → 重置视角
  TWO_HAND_PINCH = 'two_hand_pinch', // 双手 → 缩放
  SWIPE_LEFT = 'swipe_left',   // 向左挥手 → 时间减速
  SWIPE_RIGHT = 'swipe_right', // 向右挥手 → 时间加速
  THUMB_UP = 'thumb_up',       // 大拇指朝上 → 下一个行星
  THUMB_DOWN = 'thumb_down',   // 大拇指朝下 → 上一个行星
}

/** 相机动作 */
export interface CameraAction {
  type: 'focus' | 'reset' | 'zoom' | 'rotate';
  target?: { x: number; y: number; z: number };
  zoomDelta?: number;
}
